import React from 'react'
import styles from './index.module.less'

interface InfoItemProps {
  children?: React.ReactNode
  label?: React.ReactNode
}

export default function InfoItem({ children, label }: InfoItemProps) {
  return (
    <div className={styles.listItem}>
      <span className={styles.label}>{label}</span>
      <div className={styles.content}>{children}</div>
    </div>
  )
}
